import React, { useState, forwardRef, useEffect, useImperativeHandle } from 'react';
import { Modal } from 'react-bootstrap';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const VehicleForm = forwardRef((props, ref) => {
  const [vehicleModal, setVehicleModal] = useState(false);
  
  // Form state
  const [formData, setFormData] = useState({
    CustomerID: '',
    LicensePlate: '',
     MakeID: '',
    ModelID: '',
    Year: '',
    Color: '',
    VehicleType: '',
    EngineType: '',
    ImportCountry: '',
    ChassisNumber: '',
     Odometer: '',
    EngineNumber: '',
    Photo: null,
    Photo2: null,
    Photo3: null,
    Photo4: null,
    Notes: '',
    Status: '',
  });
  useEffect(() => {
    if (props.id) {
      setFormData((prevData) => ({
        ...prevData,
        CustomerID: props.id,
      }));
    }
  }, [props.id])
  console.log(formData)
  const colorOptions = [
    { value: 'white', label: 'White' },
    { value: 'black', label: 'Black' },
    { value: 'silver', label: 'Silver' },
    { value: 'gray', label: 'Gray' },
    { value: 'blue', label: 'Blue' },
    { value: 'red', label: 'Red' },
    { value: 'brown', label: 'Brown' },
    { value: 'green', label: 'Green' },
    { value: 'yellow', label: 'Yellow' },
    { value: 'gold', label: 'Gold' },
    { value: 'orange', label: 'Orange' },
    { value: 'purple', label: 'Purple' },
    { value: 'turquoise', label: 'Turquoise' },
    { value: 'beige', label: 'Beige' },
    { value: '#FFFDD0', label: 'Cream' },
    { value: 'teal', label: 'Teal' },
    { value: '#FFD1DC', label: 'Pastel Pink' },
    { value: '#A4D7E1', label: 'Pastel Blue' },
    { value: '#98FF98', label: 'Mint Green' },
    { value: 'lavender', label: 'Lavender' },
];
const countries = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", 
  "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", 
  "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", 
  "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", 
  "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Chad", 
  "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica", "Croatia", 
  "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", 
  "Ecuador", "Egypt", "El Salvador", "Estonia", "Eswatini", "Ethiopia", "Fiji", 
  "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", 
  "Grenada", "Guatemala", "Guinea", "Guyana", "Haiti", "Honduras", "Hungary", 
  "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", 
  "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Kuwait", 
  "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", 
  "Liechtenstein", "Lithuania", "Luxembourg", "Madagascar", "Malawi", "Malaysia", 
  "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", 
  "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", 
  "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands", 
  "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", 
  "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", 
  "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", 
  "Russia", "Rwanda", "Samoa", "San Marino", "Saudi Arabia", "Senegal", 
  "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", 
  "Solomon Islands", "Somalia", "South Africa", "South Korea", "Spain", 
  "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland", "Syria", 
  "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", 
  "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", 
  "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", 
  "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", 
  "Vatican City", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];


  const [makes, setMakes] = useState([]);
  const [models, setModels] = useState([]);
  const [errors, setErrors] = useState(null);
  const [photoPreview, setPhotoPreview] = useState(null); // State to hold the photo preview
  const [photoPreview2, setPhotoPreview2] = useState(null); // State to hold the photo preview
  const [photoPreview3, setPhotoPreview3] = useState(null); // State to hold the photo preview
  const [photoPreview4, setPhotoPreview4] = useState(null); // State to hold the photo preview

  // Fetch Makes from the API
  useEffect(() => {
    const fetchMakes = async () => {
      try {
        const response = await axios.get('https://subk.education.com.ly/back/api/makes'); // Adjust your API endpoint accordingly
        setMakes(response.data);
      } catch (error) {
        console.error('Error fetching makes:', error);
      }
    };
    
    fetchMakes();
  }, []);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredCountries, setFilteredCountries] = useState(countries);
  const [selectedCountry, setSelectedCountry] = useState('');

  const handleSearch = (event) => {
    const value = event.target.value.toLowerCase();
    setSearchTerm(value);
    setFilteredCountries(
      countries.filter((country) => country.toLowerCase().includes(value))
    );
  };

  const handleSelect = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
   };

  // Generate years for the dropdown
  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= currentYear - 80; year--) {
      years.push(year);
    }
    return years;
  };

  // Fetch Models based on selected Make
  const handleMakeChange = async (e) => {
    const selectedMakeId = e.target.value;
    setFormData({
      ...formData,
      MakeID: selectedMakeId,
      ModelID: '' // Reset the ModelID when Make changes
    });

    if (selectedMakeId) {
      try {
        const response = await axios.get(`https://subk.education.com.ly/back/api/models/${selectedMakeId}`); // Adjust your API endpoint accordingly
        setModels(response.data);
      } catch (error) {
        console.error('Error fetching models:', error);
      }
    } else {
      setModels([]); // Clear models if no make is selected
    }
  };

  // Handle form field change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle photo upload
  const handlePhotoChange = (e, photoField) => {
    const file = e.target.files[0];
    
    // Update form data with the file
    setFormData(prevData => ({
      ...prevData,
      [photoField]: file,
    }));
    
    // If a file is selected, create a preview for it
    if (file) {
      const reader = new FileReader();
      
      reader.onloadend = () => {
        // Based on the photoField, set the preview state
        if (photoField === 'Photo') {
          setPhotoPreview(reader.result);
        }
        if (photoField === 'Photo2') {
          setPhotoPreview2(reader.result);
        }
        if (photoField === 'Photo3') {
          setPhotoPreview3(reader.result);
        }
        if (photoField === 'Photo4') {
          setPhotoPreview4(reader.result);
        }
      };
      
      reader.readAsDataURL(file);
    } else {
      // If no file is selected, clear the preview
      if (photoField === 'Photo') setPhotoPreview(null);
      if (photoField === 'Photo2') setPhotoPreview2(null);
      if (photoField === 'Photo3') setPhotoPreview3(null);
      if (photoField === 'Photo4') setPhotoPreview4(null);
    }
  };
  
  
  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formDataToSubmit = new FormData();
    Object.keys(formData).forEach(key => {
      formDataToSubmit.append(key, formData[key]);
    });
    
    try {
      // Send POST request to the API
      const response = await axios.post('https://subk.education.com.ly/back/api/vehicles', formDataToSubmit, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      toast.success('Vehicle data submitted successfully!');
      setVehicleModal(false); // Close modal on success
      setFormData({}); // Reset form data
      setPhotoPreview(null); // Reset photo preview
    } catch (error) {
      console.error('There was an error submitting the form!', error);
      setErrors('Failed to submit vehicle data.');
    }
  };

  useImperativeHandle(ref, () => ({
    showVehicleModal() {
      setVehicleModal(true);
    },
  }));

  return (
    <Modal className="modal fade" size="xl" show={vehicleModal} centered>
      <div className="modal-content">
        <div className="modal-header">
          <h1 className="modal-title fs-5">تفاصيل السيارة</h1>
          <button type="button"style={{ marginLeft: 0 }} className="btn-close" onClick={() => setVehicleModal(false)}></button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <div className="row">
              <div className="col-xl-12">
                {errors && <div className="alert alert-danger">{errors}</div>}
              </div>
              <div className="col-xl-12" style={{ display: 'flex', paddingRight: '50px' }}>
  {['Photo', 'Photo2', 'Photo3', 'Photo4'].map((photoField, index) => (
    <div key={photoField} className="mb-3">
      <label className="form-label">الصورة {index + 1}</label>
      <div style={{ border: '1px dashed black', height: '200px', marginLeft: '10px' }} className="d-flex align-items-center justify-content-center">
        {/* Render preview image based on photoField */}
        {photoField === 'Photo' && photoPreview && (
          <img src={photoPreview} alt="" style={{ maxHeight: '100%', maxWidth: '100%' }} />
        )}
        {photoField === 'Photo2' && photoPreview2 && (
          <img src={photoPreview2} alt="" style={{ maxHeight: '100%', maxWidth: '100%' }} />
        )}
        {photoField === 'Photo3' && photoPreview3 && (
          <img src={photoPreview3} alt="" style={{ maxHeight: '100%', maxWidth: '100%' }} />
        )}
        {photoField === 'Photo4' && photoPreview4 && (
          <img src={photoPreview4} alt="" style={{ maxHeight: '100%', maxWidth: '100%' }} />
        )}
      </div>
      <input
        className="form-control"
        type="file"
        accept="image/*"
        onChange={(e) => handlePhotoChange(e, photoField)}
      />
    </div>
  ))}
</div>

                   <div className="col-xl-12">
                    <div className="row">
              {/* Organizing the inputs into 5 columns */}
              

              <div className="col-xl-2">
                <label className="form-label mt-3">رقم اللوحة<span className="text-danger">*</span></label>
                <input
                  className="form-control"
                  type="text"
                  name="LicensePlate"
                  value={formData.LicensePlate}
                  onChange={handleChange}
                  required
                />
              </div>

               

              <div className="col-xl-2">
                <label className="form-label mt-3">النوع <span className="text-danger">*</span></label>
                <select
                  className="form-control"
                  name="MakeID"
                  value={formData.MakeID}
                  onChange={handleMakeChange}
                  required
                >
                  <option value="">  اختر </option>
                  {makes.map(make => (
                    <option key={make.MakeID} value={make.MakeID}>{make.MakeName}</option>
                  ))}
                </select>
              </div>

              <div className="col-xl-2">
                <label className="form-label mt-3">الموديل <span className="text-danger">*</span></label>
                <select
                  className="form-control"
                  name="ModelID"
                  value={formData.ModelID}
                  onChange={handleChange}
                  required
                >
                  <option value="">اختر</option>
                  {models.map(model => (
                    <option key={model.ModelID} value={model.ModelID}>{model.ModelName}</option>
                  ))}
                </select>
              </div>

              <div className="col-xl-2">
                <label className="form-label mt-3">السنة<span className="text-danger">*</span></label>
                <select
                  className="form-control"
                  name="Year"
                  value={formData.Year}
                  onChange={handleChange}
                  required
                >
                  <option value="">   اختر</option>
                  {generateYears().map((year) => (
                    <option key={year} value={year}>{year}</option>
                  ))}
                </select>
              </div>

              
                <div className="col-xl-2">
                <label className="form-label mt-3">اللون <span className="text-danger">*</span></label>
                <select
                  className="form-control"
                  name="Color"
                  value={formData.Color}
                  onChange={handleChange}
                  required
                >
                  {colorOptions.map(color => (
               <option            value={color.value}       key={color.value}
                   style={{
                       backgroundColor: color.value,
                       width: '100px',
                       height: '100px',
                       margin: '10px',
                       display: 'flex',
                       justifyContent: 'center',
                       alignItems: 'center',
                       color: '#FFF',
                       fontWeight: 'bold',
                       borderRadius: '5px',
                   }}
               >
                    
                      
                      
                      {color.label}</option>
                  ))}
                </select>
              </div>
 
              <div className="col-xl-2">
                <label className="form-label mt-3">نوع الزيت</label>
                <input
                  className="form-control"
                  type="text"
                  name="VehicleType"
                  value={formData.VehicleType}
                  onChange={handleChange}
                />
              </div>

              <div className="col-xl-2">
                <label className="form-label mt-3">نوع المحرك</label>
                <input
                  className="form-control"
                  type="text"
                  name="EngineType"
                  value={formData.EngineType}
                  onChange={handleChange}
                />
              </div>

              <div className="col-xl-2">
                <label className="form-label mt-3">بلد الاستراد</label>
        
      <select
                      name="ImportCountry"

        className="form-control"
        value={formData.country}
        onChange={handleSelect}
      >
        <option value="">اختر</option>
        {filteredCountries.map((country) => (
          <option key={country} value={country}>
            {country}
          </option>
        ))}
      </select>
              </div>

              <div className="col-xl-2">
                <label className="form-label mt-3">رقم الهيكل</label>
                <input
                  className="form-control"
                  type="text"
                  name="ChassisNumber"
                  value={formData.ChassisNumber}
                  onChange={handleChange}
                />
              </div>

        
              <div className="col-xl-2">
                <label className="form-label mt-3">المسافة بالكيلومتر</label>
                <input
                  className="form-control"
                  type="number"
                  name="Odometer"
                  value={formData.Odometer}
                  onChange={handleChange}
                />
              </div>

              <div className="col-xl-2">
                <label className="form-label mt-3">رقم المحرك</label>
                <input
                  className="form-control"
                  type="text"
                  name="EngineNumber"
                  value={formData.EngineNumber}
                  onChange={handleChange}
                />
              </div>

             

              <div className="col-xl-2">
                <label className="form-label mt-3">ملاحظات</label>
                <textarea
                  className="form-control"
                  name="Notes"
                  value={formData.Notes}
                  onChange={handleChange}
                />
              </div>

             
            </div>
            </div>

            {/* Display the uploaded photo preview */}
            
          </div>
          </div>

          <div className="modal-footer">
            <button type="submit" className="btn btn-primary">حفظ</button>
            <button
              type="button"
              className="btn btn-danger light"
              onClick={() => setVehicleModal(false)}
            >
              إلغاء
            </button>
          </div>
        </form>
      </div>
      <ToastContainer />
    </Modal>
  );
});

export default VehicleForm;
